import React from 'react';
import NewsletterForm from '@App/themes/natucare/components/NewsletterForm/NewsletterForm';
import TrustmateWidget from '@Theme/natucare/modules/Footer/components/TrustmateWidget/TrustmateWidget';
import * as styles from './Footer.module.scss';
const renderLinks = (links = []) => {
  if (!links.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.rootLinksGrid
  }, links.map(({
    heading,
    items
  }, index) => {
    if (!(items !== null && items !== void 0 && items.length)) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: `${heading}-${index}`,
      className: styles.rootLinksColumn
    }, /*#__PURE__*/React.createElement("p", {
      className: styles.rootLinksHeading,
      dangerouslySetInnerHTML: {
        __html: heading
      }
    }), /*#__PURE__*/React.createElement("ul", {
      className: styles.rootLinksList
    }, items.map(({
      label,
      href
    }, itemIndex) => /*#__PURE__*/React.createElement("li", {
      key: `${label}-${itemIndex}`,
      className: styles.rootLinksItem
    }, /*#__PURE__*/React.createElement("a", {
      className: styles.rootLinksAnchor,
      href: href || '#',
      dangerouslySetInnerHTML: {
        __html: label
      }
    })))));
  }));
};
const Footer = ({
  newsletter = null,
  subscriptionStatus = {
    isSending: false,
    isSubscribed: false,
    isEmailTaken: false
  },
  onSubscribe = () => {},
  links = [],
  bottomMeta = null,
  locale = 'pl'
}) => {
  if (!newsletter && !(links !== null && links !== void 0 && links.length)) {
    return null;
  }
  const newsletterProps = {
    ...newsletter,
    subscriptionStatus,
    onSubscribe
  };
  const hasLinks = Boolean(links === null || links === void 0 ? void 0 : links.length);
  const linksContent = renderLinks(links);
  return /*#__PURE__*/React.createElement("footer", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootMain
  }, hasLinks && /*#__PURE__*/React.createElement("div", {
    className: styles.rootLinks
  }, linksContent), (newsletter || true) && /*#__PURE__*/React.createElement("div", {
    className: styles.rootAside
  }, newsletter && /*#__PURE__*/React.createElement("div", {
    className: styles.rootNewsletter
  }, /*#__PURE__*/React.createElement(NewsletterForm, Object.assign({}, newsletterProps, {
    variant: "V4Footer"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.rootTrustmate
  }, /*#__PURE__*/React.createElement(TrustmateWidget, {
    locale: locale
  }))))));
};
export default Footer;